export default __webpack_public_path__ + "static/media/produk 1.a77276c6.png";